import { render } from "./MessageConfig.vue?vue&type=template&id=6620c50c"
import script from "./MessageConfig.vue?vue&type=script&lang=ts"
export * from "./MessageConfig.vue?vue&type=script&lang=ts"
script.render = render

export default script